import * as yup from 'yup';

export const merchantSchema = () => yup.object().shape({
    name: yup
        .string()
        .required('กรุณากรอกชื่อบริษัท (ภาษาไทย)')
        .max(200, 'ไม่เกิน 200 ตัวอักษร'),
    name_en: yup.string().nullable().max(200, 'ไม่เกิน 200 ตัวอักษร'),
    // tax_id: yup
    //     .string()
    //     .required('กรุณากรอกเลขประจำตัวผู้เสียภาษี')
    //     .matches(/^[0-9]{13}$/, 'กรุณากรอกเลขประจำตัวผู้เสียภาษี 13 หลัก'),
    company_Email: yup.string().nullable().email('อีเมลไม่ถูกต้อง'),
    key_ops: yup.string().required('กรุณากรอก Key Ops'),
    key_api: yup.string().nullable(),
    branch_id: yup.string().nullable(),
    address_th: yup.string().required('กรุณากรอกที่อยู่ภาษาไทย'),
    address_en: yup.string().nullable(),
    tel: yup
        .string()
        .nullable()
        .matches(/^[0-9]*$/, 'เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น'),
    fax: yup
        .string()
        .nullable()
        .matches(/^[0-9]*$/, 'Fax ต้องเป็นตัวเลขเท่านั้น'),
    account_contact: yup.string().nullable(),
    ops_type: yup.string().required('กรุณาเลือกประเภท Key สำหรับสร้าง QR Code'),
    status_etax: yup.boolean(),
    branch_id: yup
        .string()
        .when("status_etax", {
            is: true,
            then: (schema) =>
            schema
                .required("กรุณากรอกเลขที่สาขา")
                .matches(/^\d+$/, "กรุณากรอกเฉพาะตัวเลขเท่านั้น")
                .length(5, "กรุณากรอกตัวเลขให้ครบ 5 ตัว"),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    key_api: yup
        .string()
        .when("status_etax", {
            is: true,
            then: (schema) => schema.required("กรุณากรอก API Key"),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    haveBizId: yup.boolean().nullable(),
    status_etax: yup.boolean().nullable(),
    have_pdf: yup.boolean().nullable(),
    allow_manual_payment: yup.boolean().nullable(),
    have_receipt: yup.boolean().nullable(),
    allow_edit: yup.boolean().nullable(),
    company_code: yup.string().nullable(),
});
